import { useParams } from 'react-router-dom';

import { Formik } from 'formik';
import { AlbumForm } from './album-form';
import { toast } from 'react-toastify';
import { useGetAlbumQuery, useUpdateAlbumMutation } from './albums.api';
import Routes from '../../app/routes';
import { PageTitle } from 'shared-components';
import { IAlbum, IEvent } from '@topshots/core-models';

export const Album = () => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useGetAlbumQuery(id as string);
  const [update] = useUpdateAlbumMutation();
  if (isLoading) {
    return <span>loading...</span>;
  }

  return (
    <Formik
      initialValues={{
        name: data?.name ?? '',
      }}
      enableReinitialize={true}
      onSubmit={async (values) => {
        await update({
          id: id as string,
          data: values,
        });
        toast.success('Album updated!', {
          autoClose: 2000,
        });
      }}
    >
      {({ submitForm }) => (
        <>
          <PageTitle
            title="Album"
            crumbs={[
              { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
              { display: Routes.EVENTS.title, link: Routes.EVENTS.link },
              {
                display: (data?.event_id as IEvent).name ?? '',
                link:
                  Routes.EVENT.createLink?.(
                    (data?.event_id as IEvent)._id.toString()
                  ) ?? '',
              },
              ...(data?.ancestor_ids?.map((ancestor) => ({
                display: (ancestor as IAlbum).name,
                link: Routes.ALBUM.createLink?.(ancestor._id.toString()) ?? '',
              })) ?? []),
              {
                display: data?.name ?? '',
                link: Routes.ALBUM.createLink?.(id as string) ?? '',
              },
            ]}
            allowSave={true}
            onAction={async (action) => {
              switch (action) {
                case 'save':
                  submitForm();
                  break;
              }
            }}
          />
          <AlbumForm />
        </>
      )}
    </Formik>
  );
};
